__webpack_require__.p = "https://wippen-konfigurator.web.app/";